// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/zima.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 18px;
  background-color: rgb(208,205,193);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header__content {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.header__logo {
  height: 68px;
  width: auto;
}

.header__contact {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.header__time {
  font-size: 18px;
  font-weight: 400;
  color: rgb(49,47,48);
  white-space: pre-line;
}

.header__phone {
  font-size: 18px;
  font-weight: 400;
  color: rgb(49,47,48);
  text-decoration: none;
  display: flex;
  align-items: center;
}

.header__menu {
  display: flex;
  gap: 20px;
}

.header__menu-item {
  font-size: 18px;
  font-weight: 400;
  color: rgb(49,47,48);
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  gap: 5px;
  align-items: center;
}

.header__menu-item:hover {
  opacity: .8;
}

.header__basket-wrapper {
  position: relative;
  display: inline-block;
}

.header__basket {
  height: 50px;
  width: auto;
}

@media screen and (max-width: 1100px) {
  .header__content {
    gap: 20px;
  }

  .header__menu {
    gap: 20px;
  }
}

@media screen and (max-width: 910px) {
  .header__hide {
    display: none;
  }

  .header__phone {
    font-size: 38px;
    align-self: flex-end;
  }
}

@media screen and (max-width: 520px) {
  .header__content {
    gap: 5px;
  }

  .header__menu {
    gap: 5px;
  }

  .header__logo {
    height: 48px;
  }

  .header__phone {
    font-size: 28px;
    align-self: flex-end;
  }

  .header__menu-item-image {
    height: 48px;
  }

  .header__basket {
    height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,yDAA2C;EAC3C,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 4px 18px;\r\n  background-color: rgb(208,205,193);\r\n  background-image: url('../images/zima.jpg');\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.header__content {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 30px;\r\n}\r\n\r\n.header__logo {\r\n  height: 68px;\r\n  width: auto;\r\n}\r\n\r\n.header__contact {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header__time {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: rgb(49,47,48);\r\n  white-space: pre-line;\r\n}\r\n\r\n.header__phone {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: rgb(49,47,48);\r\n  text-decoration: none;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.header__menu {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.header__menu-item {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: rgb(49,47,48);\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.header__menu-item:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.header__basket-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.header__basket {\r\n  height: 50px;\r\n  width: auto;\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .header__content {\r\n    gap: 20px;\r\n  }\r\n\r\n  .header__menu {\r\n    gap: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .header__hide {\r\n    display: none;\r\n  }\r\n\r\n  .header__phone {\r\n    font-size: 38px;\r\n    align-self: flex-end;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .header__content {\r\n    gap: 5px;\r\n  }\r\n\r\n  .header__menu {\r\n    gap: 5px;\r\n  }\r\n\r\n  .header__logo {\r\n    height: 48px;\r\n  }\r\n\r\n  .header__phone {\r\n    font-size: 28px;\r\n    align-self: flex-end;\r\n  }\r\n\r\n  .header__menu-item-image {\r\n    height: 48px;\r\n  }\r\n\r\n  .header__basket {\r\n    height: 48px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
